const TickIconSVG = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18' fill='none'>
      <path
        d='M6.75058 13.3126C6.74983 13.3126 6.74908 13.3126 6.74833 13.3126C6.59833 13.3118 6.45508 13.2518 6.34933 13.1446L3.34933 10.0981C3.13108 9.87682 3.13408 9.52059 3.35533 9.30234C3.57658 9.08484 3.93358 9.08709 4.15108 9.30834L6.75284 11.9513L13.8523 4.85182C14.0721 4.63207 14.4283 4.63207 14.6481 4.85182C14.8678 5.07157 14.8678 5.42785 14.6481 5.6476L7.14808 13.1476C7.04308 13.2534 6.89983 13.3126 6.75058 13.3126Z'
        fill='#25314C'
      />
    </svg>
  );
};

export default TickIconSVG;
